import "react";
import x from "../../../prop-types/index.js";
import S from "../../../react-clientside-effect/lib/index.es.js";
import { focusInside as I } from "../../../focus-lock/dist/es2015/focusInside.js";
import { focusIsHidden as G } from "../../../focus-lock/dist/es2015/focusIsHidden.js";
import { expandFocusableNodes as R } from "../../../focus-lock/dist/es2015/focusables.js";
import { moveFocusInside as L } from "../../../focus-lock/dist/es2015/moveFocusInside.js";
import { captureFocusRestore as D } from "../../../focus-lock/dist/es2015/return-focus.js";
import { focusNextElement as M, focusPrevElement as N, focusFirstElement as q, focusLastElement as C } from "../../../focus-lock/dist/es2015/sibling.js";
import { deferAction as b, extractRef as j } from "./util.js";
import { mediumFocus as V, mediumBlur as z, mediumEffect as A } from "./medium.js";
var J = function() {
  return document && document.activeElement === document.body;
}, K = function() {
  return J() || G();
}, f = null, s = null, d = null, v = !1, Q = function() {
  return !0;
}, U = function(e) {
  return (f.whiteList || Q)(e);
}, X = function(e, t) {
  d = {
    observerNode: e,
    portaledElement: t
  };
}, Y = function(e) {
  return d && d.portaledElement === e;
};
function W(o, e, t, r) {
  var u = null, i = o;
  do {
    var a = r[i];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (u = a);
    else if (a.lockItem) {
      if (i !== o)
        return;
      u = null;
    } else
      break;
  } while ((i += t) !== e);
  u && (u.node.tabIndex = 0);
}
var Z = function(e) {
  return e ? !!v : v === "meanwhile";
}, $ = function o(e, t, r) {
  return t && (t.host === e && (!t.activeElement || r.contains(t.activeElement)) || t.parentNode && o(e, t.parentNode, r));
}, k = function(e, t) {
  return t.some(function(r) {
    return $(e, r, r);
  });
}, h = function() {
  var e = !1;
  if (f) {
    var t = f, r = t.observed, u = t.persistentFocus, i = t.autoFocus, a = t.shards, H = t.crossFrame, g = t.focusOptions, E = r || d && d.portaledElement, n = document && document.activeElement;
    if (E) {
      var p = [E].concat(a.map(j).filter(Boolean));
      if ((!n || U(n)) && (u || Z(H) || !K() || !s && i) && (E && !(I(p) || n && k(n, p) || Y(n)) && (document && !s && n && !i ? (n.blur && n.blur(), document.body.focus()) : (e = L(p, s, {
        focusOptions: g
      }), d = {})), v = !1, s = document && document.activeElement), document && n !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var y = document && document.activeElement, l = R(p), F = l.map(function(c) {
          var m = c.node;
          return m;
        }).indexOf(y);
        F > -1 && (l.filter(function(c) {
          var m = c.guard, T = c.node;
          return m && T.dataset.focusAutoGuard;
        }).forEach(function(c) {
          var m = c.node;
          return m.removeAttribute("tabIndex");
        }), W(F, l.length, 1, l), W(F, -1, -1, l));
      }
    }
  }
  return e;
}, O = function(e) {
  h() && e && (e.stopPropagation(), e.preventDefault());
}, P = function() {
  return b(h);
}, _ = function(e) {
  var t = e.target, r = e.currentTarget;
  r.contains(t) || X(r, t);
}, ee = function() {
  return null;
};
process.env.NODE_ENV !== "production" && x.node.isRequired;
var w = function() {
  v = "just", b(function() {
    v = "meanwhile";
  });
}, te = function() {
  document.addEventListener("focusin", O), document.addEventListener("focusout", P), window.addEventListener("blur", w);
}, oe = function() {
  document.removeEventListener("focusin", O), document.removeEventListener("focusout", P), window.removeEventListener("blur", w);
};
function re(o) {
  return o.filter(function(e) {
    var t = e.disabled;
    return !t;
  });
}
var B = {
  moveFocusInside: L,
  focusInside: I,
  focusNextElement: M,
  focusPrevElement: N,
  focusFirstElement: q,
  focusLastElement: C,
  captureFocusRestore: D
};
function ne(o) {
  var e = o.slice(-1)[0];
  e && !f && te();
  var t = f, r = t && e && e.id === t.id;
  f = e, t && !r && (t.onDeactivation(), o.filter(function(u) {
    var i = u.id;
    return i === t.id;
  }).length || t.returnFocus(!e)), e ? (s = null, (!r || t.observed !== e.observed) && e.onActivation(B), h(), b(h)) : (oe(), s = null);
}
V.assignSyncMedium(_);
z.assignMedium(P);
A.assignMedium(function(o) {
  return o(B);
});
const he = S(re, ne)(ee);
export {
  he as default
};
//# sourceMappingURL=Trap.js.map
